export default __webpack_public_path__ + "static/17-f71ae93fc9cb0a8c030981b3acd87fcd.png";